import type { DashboardConfig } from '../config';
import { clusterBase } from '../clusterBase';

/*
 * "Morrisons — Disney × Stickers 2026" (program mr03): collect 120 Disney
 * stickers by scan or manual entry, earn flowpacks (lottery ticket or a prize)
 * and unlock four games. Live 2 Nov → 24 Dec 2026, one period (2026 Disney
 * Project Passport, mg1–mg4).
 *
 * Its own payload shape and page (features/morrisons), so `kind: 'morrisons'`.
 */
export const morrisonsDisneyConfig: DashboardConfig = {
  path: '/morrisons/disney-2026',
  reportId: 'morrisons-disney-2026',
  label: 'Morrisons · Disney 2026',
  endsOn: '2026-12-24', // 2 Nov → 24 Dec — archived from the day after
  kind: 'morrisons',
  // Prod backend is mngs02 on the EU cluster (passport, "Domains").
  apiBaseUrl: clusterBase('eu'),
};
